import { render, staticRenderFns } from "./ExpansionPanelHeader.vue?vue&type=template&id=1cf8a8bf&scoped=true&"
import script from "./ExpansionPanelHeader.vue?vue&type=script&lang=js&"
export * from "./ExpansionPanelHeader.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionPanelHeader.vue?vue&type=style&index=0&id=1cf8a8bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf8a8bf",
  null
  
)

export default component.exports